collections.service('OpenTradeCollection', [
    function () {

        function OpenTradeCollection(a) {
            var entities = a || [];

            this.add = function (item) {
                entities.push(item);
            };

            this.get = function (rule) {
                return _.find(entities, rule);
            };

            this.find = function (rule) {
                return _.filter(entities, rule);
            };

            this.getTrades = function () {
                return _.filter(entities, function (item) {
                    return (item.action === 'buy' || item.action === 'sell');
                });
            };

            this.getPendingTrades = function () {
                return _.filter(entities, function (item) {
                    return (item.actionCode > 1 && item.actionCode < 6);
                });
            };

            this.sort = function (rule) {
                return _.orderBy(entities, rule);
            };

            this.remove = function (rule) {
                return _.remove(entities, rule);
            };

            this.getAll = function () {
                return entities;
            };

            this.length = function () {
                return entities.length;
            };

            this.clear = function () {
                entities.forEach(function (item) {
                    if (item.clear() === 'function') {
                        item.clear();
                    }
                });
                entities = [];
            }
        }

        return OpenTradeCollection;
    }]);